import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import BrandLockup from '../components/BrandLockup';
import { membershipApi } from '../api/membershipApi';
import { useProfile } from '../context/ProfileContext';

const formatDate = (iso: string): string | null => {
  const date = new Date(iso);
  return Number.isNaN(date.getTime())
    ? null
    : date.toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });
};

const WelcomePage: React.FC = () => {
  const navigate = useNavigate();
  const { profile } = useProfile();
  const [trialEnds, setTrialEnds] = useState<string | null>(null);

  // A golfer who joined through a promo campaign link starts on a free trial: say when it ends.
  useEffect(() => {
    if (!profile.userId) return undefined;
    let cancelled = false;
    membershipApi.get(profile.userId)
      .then((membership) => {
        if (!cancelled && membership.status === 'Trialing' && membership.renewsAt) {
          setTrialEnds(formatDate(membership.renewsAt));
        }
      })
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, [profile.userId]);

  return (
    <div className="onboarding-page">
      <div className="onboarding-page__scene" aria-hidden="true" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/onboarding-bg.jpg)` }} />
      <div className="onboarding-page__shade" aria-hidden="true" />
      <section className="onboarding-card onboarding-card--narrow">
        <div className="onboarding-card__brand"><BrandLockup tone="onLight" compact /></div>
        <div className="onboarding-card__header">
          <h1>Welcome to CaddieSight</h1>
          <p>Thanks for joining us. Your account is ready, and you can head into the CaddieSight app to enjoy the game.</p>
        </div>
        {trialEnds ? <p className="welcome-trial">Your free trial runs through {trialEnds}.</p> : null}
        <Button label="Continue setup" icon="pi pi-arrow-right" onClick={() => navigate('/setup', { replace: true })} />
      </section>
    </div>
  );
};

export default WelcomePage;